/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { PureComponent } from 'react';
import { createPortal } from 'react-dom';
import {
  TouchableOpacity,
  View,
  StyleSheet,
  Animated,
  Easing,
} from 'react-native';

import Text from './Text';
import { hitSlop, themeColors } from './Constants';

type Type = 'error' | 'success' | 'removed';
type DismissButtonProps = { type: Type; onPress: () => void; style: StyleSet };
type Props = {
  children: React.ReactNode;
  toastColor: string;
  loadingColor: string;
  type: Type;
  style?: StyleSet;
};

type State = {
  right: Animated.Value;
  width: Animated.Value;
  isShown: boolean;
};

export default class Toast extends PureComponent<Props, State> {
  state: State = {
    right: new Animated.Value(0),
    width: new Animated.Value(0),
    isShown: true,
  };

  componentDidMount() {
    this._animateToast();
  }

  _animateToast = () => {
    Animated.sequence([
      Animated.timing(this.state.right, {
        toValue: 1,
        duration: 500,
        easing: (Easing as any).easeInQuint,
      } as any),
      Animated.timing(this.state.width, {
        toValue: 1,
        duration: 10000,
        easing: (Easing as any).easeOutCubic,
      } as any),
      Animated.timing(this.state.right, {
        toValue: 0,
        duration: 500,
        easing: (Easing as any).easeOutCubic,
      } as any),
    ]).start();
  };

  render() {
    let { isShown } = this.state;
    let { toastColor, loadingColor, type, style } = this.props;
    let body = document.body;
    if (isShown && body) {
      return createPortal(
        <Animated.View
          style={[
            styles.root,
            style,
            {
              right: this.state.right.interpolate({
                inputRange: [0, 1],
                outputRange: [-1000, 0],
              }),
            },
            { backgroundColor: toastColor },
          ]}
        >
          <View style={styles.content}>
            {this.props.children}
            <DismissButton
              type={type}
              style={{ paddingHorizontal: 10 }}
              onPress={() => this.setState({ isShown: false })}
            />
          </View>
          <Animated.View
            style={{
              width: this.state.width.interpolate({
                inputRange: [0, 1],
                outputRange: ['0%', '100%'],
              }),
              height: 5,
              backgroundColor: loadingColor,
              opacity: 0.4,
            }}
          />
        </Animated.View>,
        body,
      );
    }
    return null;
  }
}
function DismissButton(props: DismissButtonProps) {
  let { onPress, type, style } = props;
  let color = {
    error: themeColors.redToastText,
    removed: themeColors.orangeToastText,
    success: themeColors.greenToastText,
  };
  return (
    <TouchableOpacity
      onPress={onPress}
      hitSlop={hitSlop}
      accessibilityRole="button"
      style={style}
    >
      <Text style={[styles.dismissText, { color: color[type] }]}>×</Text>
    </TouchableOpacity>
  );
}
let styles = StyleSheet.create({
  root: {
    minWidth: 200,
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 10,
    borderRadius: 3,
    overflow: 'hidden',
  },
  content: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dismissText: {
    fontSize: 21,
    lineHeight: 20,
    color: themeColors.errorBorderRed,
    position: 'relative',
    top: -2,
  },
});
